import {Component} from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import {ErrorMessageService} from '../../../services/error-message/error-message.service';
import {GoogleAnalyticsService} from '../../../services/google-analytics/google-analytics.service';
import {Store} from '@ngrx/store';
import {LoginAction} from '../../../ngrx/actions/login/login-action';
import {LoginState} from '../../../ngrx/states/login-state';
import {map} from 'rxjs/operators';
import {whenLoaded} from '../../../helpers/when-loaded';
import {LoginStateSelector} from '../../../ngrx/selectors/login-state-selector';
import {UntilDestroy} from '@ngneat/until-destroy';
import {CurrentAccountState} from '../../../ngrx/states/current-account-state';
import {CurrentAccountSelector} from '../../../ngrx/selectors/current-account-selector';
import { FormButtonsComponent } from '../../../helpers/form/form-buttons/form-buttons.component';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { FormInputErrorsComponent } from '../../../helpers/form/form-input-errors/form-input-errors.component';
import { BijbFormDirective } from '../../../helpers/form/directives/bijb-form.directive';
import { FormsModule } from '@angular/forms';
import { NgxJsonLdModule } from '@ngx-lite/json-ld';

@UntilDestroy()
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: true,
    imports: [NgxJsonLdModule, FormsModule, BijbFormDirective, FormInputErrorsComponent, NgxTrimDirectiveModule, FormButtonsComponent, RouterLink]
})
export class LoginComponent  {

  public credentials: {
    email: string,
    password: string
  } = {email: '', password: ''};

  public error = '';
  public busy = false;

  constructor(private router: Router,
              private errMsgSvc: ErrorMessageService,
              private googleAnalyticsService: GoogleAnalyticsService,
              private currentAccountStateStore: Store<CurrentAccountState>,
              private loginStateStore: Store<LoginState>) {
    whenLoaded(this, this.currentAccountStateStore, CurrentAccountSelector)
      .pipe(map(state => state.account))
      .subscribe(account => {
        if (account != null) {
          this.googleAnalyticsService.sendEvent('login');
          this.router.navigate(['/workshop/workbench']).then();
        }
      });

    whenLoaded(this, this.loginStateStore, LoginStateSelector)
      .subscribe(state => {
        if (state.error) {
          this.error = this.errMsgSvc.generate(state.error, {
            401: 'Je emailadres is nog niet gecontroleerd. Open het emailtje dat je van ons gekregen hebt om verder te gaan. Als je dit ' +
              'mailtje niet (meer) hebt, klik dan "wachtwoord vergeten".',
            404: 'Die combinatie van gebruikersnaam en wachtwoord klopt niet.'
          });
          this.busy = false;
        } else {
          this.error = '';
        }
      });
  }

  public login(): void {
    this.error = '';
    this.busy = true;

    this.loginStateStore.dispatch(new LoginAction(this.credentials.email, this.credentials.password));
  }
}
